import { clearSprigSampleKey } from '@/lib/sprigSampling.js';

/**
 * Clears Pinia session + JS-readable auth cookies, and the HttpOnly refresh cookie via Nitro.
 * Client JS cannot clear HttpOnly cookies — hit the server endpoint when not on the server.
 */
export function useClearAuthSession() {
  const clearAuthSession = async () => {
    const sessionStore = useSessionStore();
    const { clearLoginCookies } = useLoginCookies();

    clearSprigSampleKey();

    sessionStore.clearSession();
    clearLoginCookies();

    // On SSR, clearLoginCookies with httpOnly options can clear the refresh cookie directly.
    // In the browser (and Vitest), call Nitro so HttpOnly refresh is cleared.
    if (!false) {
      try {
        await $fetch('/api/account/auth/clear-cookies', { method: 'POST' });
      } catch (err) {
        console.error('### Failed to clear auth cookies', err?.message || 'unknown error');
      }
    }
  };

  return { clearAuthSession };
}
